module.exports = __webpack_public_path__ + "img/produccion100.7334afe8.png";